export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14328.432b98aa.jpg";